(function () {
  'use strict';
  if (window.cornerstoneQuoteRequests) {
    window.cornerstoneQuoteRequests.init(document);
    return;
  }

  var turnstileReady;
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (turnstileReady) return turnstileReady;
    turnstileReady = new Promise(function (resolve, reject) {
      var script = document.querySelector('script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]');
      var timer = window.setTimeout(function () { reject(new Error('Security check unavailable')); }, 15000);
      function ready() {
        window.clearTimeout(timer);
        if (window.turnstile) resolve(window.turnstile);
        else reject(new Error('Security check unavailable'));
      }
      if (!script) {
        script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        script.addEventListener('load', ready, { once: true });
        script.addEventListener('error', function () {
          window.clearTimeout(timer);
          reject(new Error('Security check unavailable'));
        }, { once: true });
        document.head.appendChild(script);
      } else {
        script.addEventListener('load', ready, { once: true });
      }
    });
    return turnstileReady;
  }

  function bindForm(form) {
    if (form.dataset.quoteRequestBound) return;
    form.dataset.quoteRequestBound = 'true';
    var lines = form.querySelector('[data-quote-product-lines]');
    var initialLine = lines.firstElementChild.cloneNode(true);
    var addButton = form.querySelector('[data-quote-add-line]');
    var submitButton = form.querySelector('[data-quote-submit]');
    var submitLabel = form.querySelector('[data-quote-submit-label]');
    var originalLabel = submitLabel.textContent;
    var status = form.querySelector('[data-quote-status]');
    var widget = form.querySelector('[data-quote-turnstile]');
    var widgetId;
    var lineNumber = 3;
    var sending = false;
    var fields = form.elements;

    function showStatus(message, isError, focus) {
      status.textContent = message;
      status.classList.toggle('is-error', !!isError);
      status.hidden = false;
      if (focus) status.focus();
    }
    function updateLines() {
      var rows = lines.querySelectorAll('[data-quote-product-line]');
      rows.forEach(function (row, index) {
        var removeButton = row.querySelector('[data-quote-remove-line]');
        removeButton.hidden = rows.length === 1;
        removeButton.setAttribute('aria-label', 'Remove product ' + (index + 1));
      });
    }
    function addLine(focus) {
      lineNumber += 1;
      var row = initialLine.cloneNode(true);
      row.querySelectorAll('input').forEach(function (input) {
        var label = row.querySelector('label[for="' + input.id + '"]');
        input.id = input.id.replace(/-\d+$/, '-' + lineNumber);
        input.value = '';
        if (label) label.htmlFor = input.id;
      });
      lines.appendChild(row);
      updateLines();
      if (focus) row.querySelector('[data-quote-product-url]').focus();
    }
    function resetWidget() {
      if (fields.turnstile_token) fields.turnstile_token.value = '';
      if (widgetId !== undefined && window.turnstile && form.isConnected) window.turnstile.reset(widgetId);
    }

    if (widget) {
      loadTurnstile().then(function (api) {
        if (!form.isConnected) return;
        widgetId = api.render(widget, {
          sitekey: widget.dataset.sitekey,
          action: 'quote_request',
          theme: 'auto',
          size: widget.parentElement.clientWidth >= 300 ? 'normal' : 'compact',
          'response-field': false,
          callback: function (token) { fields.turnstile_token.value = token; },
          'expired-callback': function () { fields.turnstile_token.value = ''; },
          'error-callback': function () {
            fields.turnstile_token.value = '';
            showStatus('The security check could not load. Please refresh this page and try again.', true);
          }
        });
        form.quoteWidgetId = widgetId;
      }).catch(function () {
        if (form.isConnected) showStatus('The security check could not load. Please refresh this page and try again.', true);
      });
    }

    addButton.addEventListener('click', function () { if (!sending) addLine(true); });
    lines.addEventListener('click', function (event) {
      var button = event.target.closest('[data-quote-remove-line]');
      if (!button || sending || lines.children.length === 1) return;
      var row = button.closest('[data-quote-product-line]');
      var nextRow = row.nextElementSibling || row.previousElementSibling;
      row.remove();
      updateLines();
      nextRow.querySelector('[data-quote-product-url]').focus();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (sending) return;
      status.hidden = true;
      var payload = new URLSearchParams();
      var products = [];
      var invalidField;

      lines.querySelectorAll('[data-quote-product-line]').forEach(function (row) {
        var urlField = row.querySelector('[data-quote-product-url]');
        var quantityField = row.querySelector('[data-quote-product-quantity]');
        urlField.value = urlField.value.trim();
        if (!urlField.value) return;
        var quantity = Number(quantityField.value);
        if (!urlField.checkValidity()) {
          invalidField = invalidField || urlField;
        } else if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100000) {
          invalidField = invalidField || quantityField;
        } else {
          products.push({ product_url: urlField.value, quantity: quantity });
        }
      });

      // Check contact fields separately so entirely unused product rows are optional.
      form.querySelectorAll('[required]').forEach(function (field) {
        field.value = field.value.trim();
        if (!field.checkValidity() && !invalidField) invalidField = field;
      });
      if (invalidField) {
        showStatus('Please complete the required fields and add a valid product link with a whole-number quantity from 1 to 100,000.', true);
        invalidField.focus();
        invalidField.reportValidity();
        return;
      }
      if (!products.length) {
        showStatus('Please add at least one product link for your quote.', true);
        lines.querySelector('[data-quote-product-url]').focus();
        return;
      }
      if (!widget || !fields.turnstile_token.value.trim()) {
        showStatus('Please complete the security check before sending your quote request.', true, true);
        return;
      }

      ['first_name', 'last_name', 'company', 'email', 'phone', 'address', 'city', 'state', 'zip', 'notes', 'page_title', 'page_handle', 'source_url', 'store_name', 'turnstile_token', 'website'].forEach(function (name) {
        payload.set(name, fields.namedItem(name).value.trim());
      });
      payload.set('email_consent', fields.email_consent.checked ? '1' : '0');
      products.forEach(function (product, index) {
        payload.set('products[' + index + '][product_url]', product.product_url);
        payload.set('products[' + index + '][quantity]', String(product.quantity));
      });

      sending = true;
      form.setAttribute('aria-busy', 'true');
      var controls = Array.from(form.querySelectorAll('input:not([type="hidden"]), textarea, button')).filter(function (control) { return !control.disabled; });
      controls.forEach(function (control) { control.disabled = true; });
      submitLabel.textContent = 'Sending request…';
      showStatus('Sending your quote request…', false);

      // URL-encoded fields avoid the API's JSON preflight issue and match PHP's nested products array.
      fetch(form.action, { method: 'POST', body: payload, credentials: 'omit' })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          return response.json();
        })
        .then(function (result) {
          if (!result || result.success !== true || result.error) throw new Error('Request rejected');
          form.reset();
          while (lines.children.length > 3) lines.lastElementChild.remove();
          while (lines.children.length < 3) addLine(false);
          updateLines();
          showStatus('Thank you — your quote request has been sent. Our team will be in touch soon.', false, true);
        })
        .catch(function () {
          showStatus('We could not send your request just now. Your details are still here. Please try again or contact us directly.', true, true);
        })
        .finally(function () {
          resetWidget();
          controls.forEach(function (control) { control.disabled = false; });
          submitLabel.textContent = originalLabel;
          form.removeAttribute('aria-busy');
          sending = false;
        });
    });
    updateLines();
  }

  function init(root) { root.querySelectorAll('[data-quote-request-form]').forEach(bindForm); }
  window.cornerstoneQuoteRequests = { init: init };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-quote-request-form]').forEach(function (form) {
      if (form.quoteWidgetId !== undefined && window.turnstile) window.turnstile.remove(form.quoteWidgetId);
    });
  });
})();
